module.exports = __webpack_public_path__ + "img/hobbiton-3018-09-29.1492e838.jpg";